import { createAction, props } from '@ngrx/store';
import { User } from '../../core/models/user.model';
import { Notification } from '../../core/models/notification.model';
import { XpGain } from '../../core/models/xp.model';

// Auth state
export const setUser = createAction('[User] Set User', props<{ user: User | null }>());
export const clearUser = createAction('[User] Clear User');

// Notifications
export const loadNotifications = createAction('[User] Load Notifications');
export const loadNotificationsSuccess = createAction(
  '[User] Load Notifications Success',
  props<{ notifications: Notification[] }>()
);
export const setUnreadCount = createAction('[User] Set Unread Count', props<{ count: number }>());
export const markNotificationRead = createAction(
  '[User] Mark Notification Read',
  props<{ notificationId: string }>()
);
export const markAllNotificationsRead = createAction('[User] Mark All Read');

// Preferences
export const setTheme = createAction('[User] Set Theme', props<{ theme: 'light' | 'dark' | 'system' }>());
export const setLanguage = createAction('[User] Set Language', props<{ language: string }>());

// XP & Levels
export const awardXp = createAction('[User] Award XP', props<{ gain: XpGain }>());
export const levelUp = createAction('[User] Level Up', props<{ newLevel: number }>());
